var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "range-container" },
    [
      _c("h2", [
        _vm._v(_vm._s(_vm.start) + " "),
        _c("span", [_vm._v("-")]),
        _vm._v(" " + _vm._s(_vm.end))
      ]),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "text-right p-0 m-auto", attrs: { cols: "1" } },
                [_vm._v("\n        0\n      ")]
              ),
              _vm._v(" "),
              _c("b-col", { staticClass: "m-auto", attrs: { cols: "8" } }, [
                _c(
                  "div",
                  [
                    _c(
                      "b-progress",
                      { attrs: { max: 100 } },
                      [
                        _c("b-progress-bar", {
                          attrs: { value: _vm.start, variant: "white" }
                        }),
                        _vm._v(" "),
                        _c("b-progress-bar", {
                          staticClass: "progress-slider",
                          style: { backgroundColor: _vm.color },
                          attrs: { value: _vm.end - _vm.start }
                        }),
                        _vm._v(" "),
                        _c("b-progress-bar", {
                          attrs: { value: 100 - _vm.end, variant: "white" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "m-auto p-0 text-left", attrs: { cols: "1" } },
                [_vm._v("\n        100\n      ")]
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "2" } }, [
                _c(
                  "div",
                  {
                    staticClass: "selected-color",
                    style: { backgroundColor: _vm.dataColor },
                    attrs: { id: "popColorPick-" + _vm.start },
                    on: { click: _vm.focusPicker }
                  },
                  [
                    _c(
                      "b-popover",
                      {
                        attrs: {
                          target: "popColorPick-" + _vm.start,
                          triggers: "click blur"
                        }
                      },
                      [
                        _c("ColorPicker", {
                          ref: "colorpicker",
                          on: { colorSelected: _vm.setColor }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5915d43e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5915d43e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/range.vue
// module id = 1323
// module chunks = 2